import { render } from "./EditCustomer.vue?vue&type=template&id=168bb5ca&scoped=true"
import script from "./EditCustomer.vue?vue&type=script&lang=js"
export * from "./EditCustomer.vue?vue&type=script&lang=js"

import "./EditCustomer.vue?vue&type=style&index=0&id=168bb5ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168bb5ca"]])

export default __exports__